import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CheckboxCircleBlankIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CheckboxCircleBlankIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CheckboxCircleBlankIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CheckboxCircleBlankIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CheckboxCircleBlankIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 1.5a6 6 0 100 12 6 6 0 000-12zm2.705 4.28a.75.75 0 010 1.061L7.462 9.584a.75.75 0 01-1.06 0L5.03 8.212a.75.75 0 011.061-1.06l.84.84L9.144 5.78a.75.75 0 011.061 0z"
      />
    </svg>
  )
);
CheckboxCircleBlankIcon.displayName = "CheckboxCircleBlankIcon";
export default CheckboxCircleBlankIcon;
